import React from "react";

import { List } from "@material-ui/core";

import ScrollBars from "components/ScrollBars";
import DesktopContainerDrawer from "containers/DesktopContainerDrawer";
import MenuGroup from "containers/MenuGroup";
import MobileContainerDrawer from "containers/MobileContainerDrawer";

import makeStyles from "hooks/makeStyles";
import useMenu from "hooks/useMenu";

const useStyles = makeStyles(theme => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		margin: 0,
		// paddingLeft: theme.spacing(1.5),
		// paddingRight: theme.spacing(1.5),
		paddingBottom: "50vh", // FIX:  add padding to the end of the menu so the last section can scroll up
		marginTop: 35,
		position: "relative",
		[theme.breakpoints.up(480)]: {
			marginTop: 0,
			display: "flex",
			flexDirection: "column",
			background: "none",
			paddingBottom: "10vh"
		}
	},
	scroll: {
		height: `calc(100vh - ${theme.businessHeaderHeight + 100}px)`
	},
	section: {
		padding: 0
	}
}));

const InnerMenu = () => {
	const { menu } = useMenu();
	const classes = useStyles();

	return (
		<>
			<List className={classes.root} subheader={<li />}>
				{menu.menuGroups.map(group => (
					<li key={group.id} className={classes.section}>
						<MenuGroup menuGroupSlug={group.slug} />
					</li>
				))}
			</List>
		</>
	);
};

const Menu = () => {
	const classes = useStyles();
	return (
		<>
			<DesktopContainerDrawer>
				<ScrollBars className={classes.scroll}>
					<InnerMenu />
				</ScrollBars>
			</DesktopContainerDrawer>
			<MobileContainerDrawer>
				<InnerMenu />
			</MobileContainerDrawer>
		</>
	);
};

export default Menu;
